import * as Sports from '../../../../../../constants/SportType';
import { getSoccerScores } from './soccer';
import { getTennisScores } from './tennis';
import { getBasketballScores } from './basketball';
import { getGenericScores } from './generic';
export default function (sportId, scores) {
    switch (sportId) {
        case Sports.FOOTBALL:
            return getSoccerScores(scores);
        case Sports.TENNIS:
            return getTennisScores(scores);
        case Sports.BASKETBALL:
            return getBasketballScores(scores);
        default:
            return getGenericScores(scores, sportId);
    }
}



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/statistics/mainScores/mainScore.js